module.exports = __webpack_public_path__ + "img/tv.77a9c365.svg";